import http from "./http";
import { wOrgIdMiddleware } from "../utils/commonUtils";
import { CREATED, OK } from "../utils/constant";

const DaisyBillService = {
  /**
   * Validate all requirements before submitting to Daisy Bill
   * @param {string} visitId - Visit ID
   * @returns {Promise<Object>}
   */
  validateRequirements: wOrgIdMiddleware(async (url, visitId) => {
    try {
      const response = await http.GET(`${url}daisy-bill/validate-requirements/${visitId}`);
      if (response.code === OK) {
        return response.data || response;
      }
      return response;
    } catch (error) {
      console.error("Error validating Daisy Bill requirements:", error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }),

  /**
   * Process complete flow for new injury billing
   * This handles: check patient -> create/add injury -> create bill
   * @param {string} visitId - Visit ID
   * @returns {Promise<Object>}
   */
  processNewInjuryBilling: wOrgIdMiddleware(async (url, visitId) => {
    try {
      const response = await http.POST(`${url}daisy-bill/process-billing/${visitId}`, {});
      if (response.code === OK || response.code === CREATED) {
        return response.data || response;
      }
      return response;
    } catch (error) {
      console.error("Error processing new injury billing in Daisy Bill:", error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }),

  /**
   * Attach document to a Daisy Bill bill
   * @param {number} billId - Bill ID
   * @param {string} documentFileContent - Base64 encoded PDF content
   * @param {string} reportType - Report type code
   * @returns {Promise<Object>}
   */
  attachDocumentToBill: wOrgIdMiddleware(async (url, billId, documentFileContent, reportType) => {
    try {
      const response = await http.POST(
        `${url}daisy-bill/bills/${billId}/attachments`,
        {
          document_file_content: documentFileContent,
          report_type: reportType,
        }
      );
      if (response.code === OK || response.code === CREATED) {
        return response.data || response;
      }
      return response;
    } catch (error) {
      console.error("Error attaching document to Daisy Bill:", error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      throw error;
    }
  }),
};

export default DaisyBillService;

